import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { environment } from "src/environments/environment";
import { Router} from "@angular/router";

declare var gtag;
declare var fbq;
@Component({
  selector: 'app-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.css']
})
export class CareersComponent implements OnInit {

  constructor(private service:AppService,private router: Router) { }

  careerList:any=[];
  errorMsg:any="";
  loader:boolean=false;

  ngOnInit() {
    if(environment.production){
    this.service.sendEvents("Completecareers", "careers", "Careers");

    fbq('track', "CompleteCareers" , {
      content_type: "careers",
      content_title: this.router.url,
    });
  }
    
    this.loader=true;
    this.service.get('/careerList').subscribe(
      (data:any)=>{
        if(data[0].error=='0'){
          this.careerList=data[0].result;
        }else{
          this.errorMsg=data[0].msg;
        }
        this.loader=false;
      },error=>{
        this.loader=false;
        this.errorMsg=error.errorDesc;
      }
    )
  }

}
